export const GetCountries = async () => {
    try {
        return [
            {
                value: '840',
                label: 'USA'
            },
            {
                value: '124',
                label: 'Canada'
            }
        ];

    } catch (error) {
        console.error('Error fetching states:', error);
        throw error;
    }
};